<template>
  <section>
    <v-card>
      <v-card-text>
        <v-alert dark dense prominent color="primary" icon="mdi-school" class="mb-0">
          <v-row align="center">
            <v-col class="grow">
              Student answer templates
            </v-col>
            <v-col class="shrink">
              <v-btn small @click="openCreateItemDialog">create new</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>
    </v-card>

    <v-dialog v-model="create_item_dialog" @click:outside="closeCreateItemDialog" max-width="500px">
      <v-form v-if="create_item" @submit="saveCreateItem">
        <v-card v-if="create_item">
          <v-toolbar dense dark color="primary">
            Create
            <v-spacer/>
            <v-btn icon @click="closeCreateItemDialog"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-text-field label="Title" v-model="create_item.title" outlined></v-text-field>
            <v-select v-model="create_item.mimetype" :items="mimetypes" outlined></v-select>

          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-space-between">
            <v-btn text @click="closeCreateItemDialog">cancel</v-btn>
            <v-btn color="primary" type="submit">create</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-container fluid>
      <v-data-table :headers="headers" :items="templates">
        <template v-slot:item.google_mimetype="{ item }">
          <v-avatar tile>
            <img :src="`/img/google/${getItemIcon(item)}.png`" alt=""/>
          </v-avatar>
        </template>

        <template v-slot:item.google_view_link="{ value }">
          <v-btn small color="success" target="_blank" :disabled="!value" :href="value">
            <v-icon>mdi-link</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.publish="{ item }">
          <v-btn small color="primary" @click="publishItem(item)">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn small color="primary" @click="openSelectedItemDialog(item)">
            <v-icon>mdi-cog</v-icon>
          </v-btn>

          <v-btn small color="error" @click="openDeleteItemDialog(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="publish_item_dialog" @click:outside="closePublishItemDialog" max-width="500px">
      <v-card v-if="publish_item">
        <v-toolbar dense dark color="primary">
          Publish
          <v-spacer/>
          <v-btn icon @click="closePublishItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="closePublishItemDialog">cancel</v-btn>
          <v-btn color="primary" @click="publishItem">Publish</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog" max-width="500px">
      <v-form v-if="selected_item" @submit="updateSelectedItem">
        <v-card>
          <v-toolbar dense dark color="primary">
            Settings
            <v-spacer/>
            <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-text-field label="Title" v-model="selected_item.title" outlined></v-text-field>
          </v-card-text>
          <v-divider/>
          <template v-if="!selected_item.type">
            <v-card-text class="pt-4">
              <vue-editor v-model="selected_item.body" :editor-toolbar="toolbar"/>
            </v-card-text>
            <v-divider/>
          </template>

          <v-card-actions class="justify-space-between">
            <v-btn text @click="closeSelectedItemDialog">cancel</v-btn>
            <v-btn color="primary" type="submit">update</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="delete_item_dialog" @click:outside="closeDeleteItemDialog" max-width="500px">
      <v-card v-if="delete_item">
        <v-toolbar dense color="error">
          Delete
          <v-spacer/>
          <v-btn icon @click="closeDeleteItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="closeDeleteItemDialog">cancel</v-btn>
          <v-btn color="error" @click="submitDeleteItem">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    templates: [],
    headers: [
      { text: 'Mimetype', value: 'google_mimetype' },
      { text: 'Title', value: 'title' },
      // { text: 'External ID', value: 'google_drive_id' },
      { text: 'Link', value: 'google_view_link' },
      { text: 'Publish', value: 'publish' },
      { text: 'Actions', value: 'actions' },
    ],

    mimetypes: [
      {value: 'application/vnd.google-apps.document', text: 'Document', icon: 'document'},
      {value: 'application/vnd.google-apps.drawing', text: 'Drawing', icon: 'drawing'},
      {value: 'application/vnd.google-apps.form', text: 'Form', icon: 'form'},
      {value: 'application/vnd.google-apps.presentation', text: 'Presentation', icon: 'presentation'},
      {value: 'application/vnd.google-apps.spreadsheet', text: 'Sheets', icon: 'spreadsheet'},
      // {value: 'application/vnd.google-apps.photo', text: 'Photo', icon: 'photo'},
      // {value: 'application/vnd.google-apps.video', text: 'video', icon: 'video'},
    ],
    create_item: null,
    create_item_dialog: false,

    publish_item: null,
    publish_item_dialog: false,

    selected_item: null,
    selected_item_dialog: false,

    delete_item: null,
    delete_item_dialog: false,

    body: '',
    new_answer_template: null,
    new_answer_template_dialog: false,

    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["link", "formula"],
    ],
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.templates = await this.axios.get(`api/mocks/${this.$route.params.mock_id}/answer-templates`)
          .then(({data}) => data.data)
    },
    getItemIcon(_item) {
      if(_item.google_mimetype) {
        let mimetype = this.mimetypes.find(item => item.value === _item.google_mimetype)
        if(mimetype) return mimetype.icon
      }
      return null
    },
    openCreateItemDialog() {
      this.create_item = {
        title: '',
        mimetype: 'application/vnd.google-apps.document',
      }
      this.create_item_dialog = true
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false
      this.create_item = null
    },
    saveCreateItem(e) {
      e.preventDefault()
      this.api_errors = []
      this.app_loading = true
      this.axios.post(`api/mocks/${this.$route.params.mock_id}/answer-templates`, this.create_item)
          .then(({data}) => {
            this.templates.push(data.data)
            this.closeCreateItemDialog()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors })
          .then(() => {this.app_loading = false})
    },

    openPublishItemDialog(item) {
      this.publish_item = item
      this.publish_item_dialog = true
    },
    closePublishItemDialog() {
      this.publish_item_dialog = false
      this.publish_item = null
    },
    publishItem(item) {
      this.axios.post(`api/mocks/${this.$route.params.mock_id}/answer-templates/${item.id}/publish`)
          .then(() => {
            this.$notify('Published', 'success')
            this.loadData()
          })
    },

    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    updateSelectedItem() {
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/answer-templates/${this.selected_item.id}`, this.selected_item)
          .then(() => {
            this.closeSelectedItemDialog()
            this.$notify('Updated', 'success')
          })
    },
    openDeleteItemDialog(item) {
      this.delete_item = item
      this.delete_item_dialog = true
    },
    closeDeleteItemDialog() {
      this.delete_item_dialog = false
      this.delete_item = null
    },
    submitDeleteItem() {
      this.axios.delete(`api/mocks/${this.$route.params.mock_id}/answer-templates/${this.delete_item.id}`)
          .then(() => {
            this.$notify('Deleted', 'success')
            this.closeDeleteItemDialog()
            this.loadData()
          })
    },

    openNewAnswerTemplateDialog() {
      this.new_answer_template = {
        title: '',
        body: '',
      }
      this.new_answer_template_dialog = true
    },
    closeNewAnswerTemplateDialog() {
      this.new_answer_template_dialog = false
      this.new_answer_template = null
    },
    createNewAnswerTemplate() {
      this.api_errors = []
      this.axios.post(`api/mocks/${this.$route.params.mock_id}/answer-templates`, this.new_answer_template)
          .then(({data}) => {
            this.templates.push(data.data)
            this.closeNewAnswerTemplateDialog()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors })
          .then(() => {this.app_loading = false})
    },
    update(template) {
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/answer-templates/${template.id}`, template)
          .then(() => {this.$notify('Updated', 'success')})
    },
    destroy(template) {
      this.axios.delete(`api/mocks/${this.$route.params.mock_id}/answer-templates/${template.id}`)
          .then(() => {
            this.$notify('Deleted', 'success')
            this.loadData()
          })
    },
  }
}
</script>
